module.exports = __webpack_public_path__ + "img/prykarp_energo.8b6532f2.png";